export const SWIPE_AXIS_LOCK_PX = 12
export const SWIPE_DIAGONAL_RATIO = 1.35
export const SWIPE_DISMISS_PX = 72
export const SWIPE_DISMISS_RATIO = 0.28
export const SWIPE_FLICK_DISTANCE_PX = 28
export const SWIPE_FLICK_VELOCITY = 0.55
export const SWIPE_EXIT_MS = 220
export const SWIPE_SNAP_MS = 200
export const PHONE_LAYOUT_QUERY = '(max-width: 768px), (max-height: 460px) and (orientation: landscape)'

export function swipePointerAllowed(pointerType, phoneLayout = false) {
  if (pointerType === 'touch' || pointerType === 'pen') return true
  return pointerType === 'mouse' && Boolean(phoneLayout)
}

export function isSwipeInteractiveTarget(target) {
  return Boolean(target?.closest?.('button, a, input, textarea, select, [data-no-swipe]'))
}

export function resolveSwipeAxis({
  dx,
  dy,
  lockPx = SWIPE_AXIS_LOCK_PX,
  diagonalRatio = SWIPE_DIAGONAL_RATIO,
}) {
  const adx = Math.abs(dx)
  const ady = Math.abs(dy)
  if (adx < lockPx && ady < lockPx) return 'undecided'
  if (adx >= lockPx && adx > ady * diagonalRatio) return 'horizontal'
  if (ady >= lockPx && ady >= adx) return 'vertical'
  return 'ambiguous'
}

export function swipeDismissThreshold(width) {
  const size = Number(width)
  const safe = Number.isFinite(size) && size > 0 ? size : 0
  return Math.max(SWIPE_DISMISS_PX, safe * SWIPE_DISMISS_RATIO)
}

export function shouldCommitSwipe({ dx, width, velocityX = 0 }) {
  const distance = Math.abs(dx)
  if (distance < SWIPE_AXIS_LOCK_PX) return false
  if (distance >= swipeDismissThreshold(width)) return true
  const sameDirection = dx !== 0 && Math.sign(velocityX) === Math.sign(dx)
  return sameDirection && Math.abs(velocityX) >= SWIPE_FLICK_VELOCITY && distance >= SWIPE_FLICK_DISTANCE_PX
}

export function swipeExitX(dx, width) {
  const size = Math.max(Number(width) || 0, Math.abs(dx) + 48, SWIPE_DISMISS_PX)
  return (dx < 0 ? -1 : 1) * size
}

export function swipeFollowOpacity(dx, width) {
  const threshold = swipeDismissThreshold(width)
  return Math.max(0.18, 1 - Math.abs(dx) / Math.max(threshold * 1.85, 1))
}

export function matchesPhoneLayout(media = globalThis.matchMedia) {
  if (typeof media !== 'function') return false
  return Boolean(media(PHONE_LAYOUT_QUERY).matches)
}
